import { render, staticRenderFns } from "./studentAccount.vue?vue&type=template&id=02dccb5b&scoped=true&"
import script from "./studentAccount.vue?vue&type=script&lang=js&"
export * from "./studentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dccb5b",
  null
  
)

export default component.exports